`<template>
  <div class="myinfo">
    <div class="choosetopic" v-if="content">
      <h1><span></span>论文选题</h1>
      <div class="backlast">
        <button @click="$router.back(-1)" class="btn back">
          <i class="iconfont icon-fanhui"></i> 返回到上一页
        </button>
      </div>
      <div class="form-group row">
        <label class="col-md-2 control-label">论文标题</label>
        <div class="col-md-10">
          <input
            type="text"
            readonly="readonly"
            :value="content.title"
            class="form-control topictitle"
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-md-2 control-label">下载模板</label>
        <div class="col-md-10">
          <div class="download" v-if="tempUrl">
            <span> <a :href="tempUrl">模板1</a></span>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-md-2 control-label">选择导师</label>
        <div class="col-md-10">
          <div class="info">
            <div>
              <select class="form-control select" @change="change($event)">
                <option
                  v-for="item in teachers"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-md-2 control-label">备注</label>
        <div class="col-md-10">
          <div class="info">
            <span class="title">论文选择说明：</span>
            <div v-html="content.remarks"></div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-md-2 control-label">&nbsp;&nbsp;&nbsp;&nbsp;</label>
        <div class="col-md-10">
          <a-spin :spinning="submitSpinning">
            <button type="submit" class="btn btn-info" @click="submit">
              确认选题
            </button>
          </a-spin>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HomeHeader from '@/common/components/Header'
import Foot from '@/common/components/Foot'
import PersonalCenter from '@/common/components/PersonalCenter'

export default {
  name: 'ChangeStateFirst',
  components: {
    PersonalCenter,
    HomeHeader,
    Foot,
  },
  data: function () {
    return {
      content: null,
      tempUrl: null,
      teachers: null,
      selectedTeacher: null,
      timeId: null,
      submitSpinning: false,
    }
  },
  mounted () {
    this.getThesis()
  },
  methods: {
    getThesis () {
      if (!this.$route.query.index) return
      const index = this.$route.query.index
      this.axios.get(`/biz/thesis/time`).then((res) => {
        if (res.success) {
          this.timeId = res.result.id
          this.teachers = res.result.teacherIds
          this.selectedTeacher = this.teachers[0].id
          this.content = res.result.titleIds[index]
          this.tempUrl = this.content.tempUrl ? this.content.tempUrl : ''
        }
      })
    },
    change (e) {
      console.log(e.target.value)
      this.selectedTeacher = e.target.value
    },
    // postAllSelect(timeId, teacherId, titleId) {
    //   return Promise.all([
    //     this.axios.get(`/biz/thesis/confirm/teacher`, {
    //       params: {
    //         teacher_id: teacherId,
    //         time_id: timeId,
    //       },
    //     }),
    //     this.axios.get(`/biz/thesis/confirm/title`, {
    //       params: {
    //         title_id: titleId,
    //         time_id: timeId,
    //       },
    //     }),
    //   ]);
    // },
    submit () {
      this.submitSpinning = true
      console.log('this is submit')
      this.axios.get(`/biz/thesis/confirm/titleAndTeacher`, {
        params: {
          teacher_id: this.selectedTeacher,
          time_id: this.timeId,
          title_id: this.content.id,
        },
      }).then((res) => {
        console.log('成功 ', res)
        if (res.success) {
          this.$message.success(res.message)
          this.$router.push('/graduationmanagement')
          this.submitSpinning = false
        }
      })
        .catch((err) => {
          console.log('失败', err)
          this.submitSpinning = false
        })
      // this.postAllSelect(this.timeId, this.selectedTeacher, this.content.id)
      //   .then((res) => {
      //     if (res[0].success && res[1].success) {
      //       console.log(res);
      //       this.$message.success("选题成功");
      //       this.$router.push("/graduationmanagement");
      //     }
      //     this.submitSpinning = false;
      //   })
      //   .catch((err) => {
      //     this.submitSpinning = false;
      //   });
    },
  },
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

h1 {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 20px;

  span {
    display: inline-block;
    width: 5px;
    height: 16px;
    background: $bgColor;
    margin-right: 10px;
  }
}

.myinfo {
  .page-width {
    width: $pageWidth;
    margin: 0 auto;
    margin-top: 20px;
    margiin-bottom: 30px;
  }

  .choosetopic {
    background: #fff;
    padding: 28px;
  }
}

.download {
  span {
    margin-right: 30px;

    a {
      color: $bgColor;
      text-decoration: underline;
    }
  }
}

.btn-info {
  background: $bgColor;
}

.info {
  line-height: 30px;

  span {
    font-weight: bold;
  }
}

.back {
}

.topictitle {
  font-size: 16px;
  font-weight: bold;
}

.backlast {
  padding: 5px;
  background: $bgcontent;

  .btn {
    color: $bgColor;
  }

  border-radius: 5px;
  margin-bottom: 20px;
}

.control-label {
  color: #999;
}

.info {
  color: #999;

  .title {
    color: #333;
  }
}

.form-control {
  padding: 0;
  background: none;
  border: none;
  height: 24px;
}

.select {
  border: 1px solid #ced4da;
}
</style>



// WEBPACK FOOTER //
// src/pages/graduationmanagement/components/ChangeStateFirsttopic.vue